<template>
  <div class="min-h-screen bg-slate-950 flex items-center justify-center p-4 sm:p-6 relative overflow-hidden font-sans selection:bg-indigo-500 selection:text-white">

    <!-- Grid de Fondo Tecnológico -->
    <div class="absolute inset-0 bg-[linear-gradient(to_right,#1e293b15_1px,transparent_1px),linear-gradient(to_bottom,#1e293b15_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none"></div>

    <!-- Luces difuminadas de fondo -->
    <div class="absolute top-[-15%] left-[-15%] w-[500px] h-[500px] bg-indigo-600/20 rounded-full blur-[140px] pointer-events-none animate-pulse"></div>
    <div class="absolute bottom-[-15%] right-[-15%] w-[500px] h-[500px] bg-violet-600/20 rounded-full blur-[140px] pointer-events-none"></div>

    <div class="w-full max-w-xl relative z-10 animate-fade-in my-8">

      <!-- CABECERA CON TU LOGO -->
      <div class="text-center mb-6 space-y-2">
        <div class="inline-flex items-center justify-center mb-2">
          <img
            src="@/assets/img/logo_neurals_nuevo.png"
            alt="Neurals Logo"
            class="h-10 w-auto object-contain brightness-0 invert drop-shadow-[0_0_12px_rgba(255,255,255,0.3)] transition-transform hover:scale-105"
          />
        </div>
        <h1 class="text-2xl sm:text-3xl font-extrabold text-white tracking-tight">
          Crea tu cuenta empresarial
        </h1>
        <p class="text-slate-400 text-sm">Despliega tus agentes inteligentes en minutos.</p>
      </div>

      <!-- TARJETA EN MODO OSCURO (Glassmorphism) -->
      <div class="bg-slate-900/80 backdrop-blur-xl border border-slate-800 rounded-3xl p-6 sm:p-10 shadow-2xl shadow-black/60 relative">

        <!-- Alerta de Error -->
        <div v-if="errorMessage" class="mb-6 p-4 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center gap-3 text-red-400 animate-fade-in text-sm">
          <AlertCircle class="w-5 h-5 flex-shrink-0 text-red-400" />
          <span class="font-medium">{{ errorMessage }}</span>
        </div>

        <form @submit.prevent="handleSignup" class="space-y-4" novalidate>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Nombre Completo -->
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider block">
                Nombre / Empresa
              </label>
              <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <User class="w-4 h-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
                </div>
                <input
                  v-model="form.full_name"
                  type="text"
                  class="w-full pl-10 pr-4 py-2.5 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                  placeholder="Ej: Inversiones Gómez"
                  required
                />
              </div>
            </div>

            <!-- Documento (RUT / ID) -->
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider block">
                Documento Comercial
              </label>
              <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <FileText class="w-4 h-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
                </div>
                <input
                  v-model="form.document"
                  type="text"
                  class="w-full pl-10 pr-4 py-2.5 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                  placeholder="Ej: J-12345678"
                />
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Correo Electrónico -->
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider block">
                Correo Electrónico
              </label>
              <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <Mail class="w-4 h-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
                </div>
                <input
                  v-model="form.email"
                  type="email"
                  class="w-full pl-10 pr-4 py-2.5 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                  placeholder="admin@empresa.com"
                  required
                />
              </div>
            </div>

            <!-- Username -->
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider block">
                Nombre de Usuario
              </label>
              <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <AtSign class="w-4 h-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
                </div>
                <input
                  v-model="form.username"
                  type="text"
                  class="w-full pl-10 pr-4 py-2.5 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all lowercase no-uppercase"
                  placeholder="inversiones_go"
                  pattern="[a-zA-Z0-9_]+"
                  title="Solo minúsculas, números y guiones bajos"
                  required
                />
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Contraseña -->
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider block">
                Contraseña
              </label>
              <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <Lock class="w-4 h-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
                </div>
                <input
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  class="w-full pl-10 pr-11 py-2.5 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  @click="showPassword = !showPassword"
                  tabindex="-1"
                  class="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-300 transition-colors cursor-pointer"
                >
                  <component :is="showPassword ? EyeOff : Eye" class="w-4 h-4" />
                </button>
              </div>
            </div>

            <!-- Confirmar Contraseña -->
            <div class="space-y-1.5">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider block">
                Confirmar Contraseña
              </label>
              <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <Lock class="w-4 h-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
                </div>
                <input
                  v-model="form.password_confirmation"
                  :type="showPasswordConfirm ? 'text' : 'password'"
                  class="w-full pl-10 pr-11 py-2.5 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  @click="showPasswordConfirm = !showPasswordConfirm"
                  tabindex="-1"
                  class="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-300 transition-colors cursor-pointer"
                >
                  <component :is="showPasswordConfirm ? EyeOff : Eye" class="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <!-- Botón de Envío -->
          <button
            type="submit"
            :disabled="isLoading"
            class="w-full !mt-6 bg-gradient-to-r from-indigo-600 via-indigo-500 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-bold py-3 px-4 rounded-xl shadow-lg shadow-indigo-600/25 transition-all duration-200 flex justify-center items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed active:scale-[0.98] cursor-pointer"
          >
            <Loader2 v-if="isLoading" class="w-5 h-5 animate-spin" />
            <span v-else>Crear mi cuenta empresarial</span>
          </button>
        </form>

        <div class="mt-6 text-center border-t border-slate-800/60 pt-4">
          <p class="text-xs text-slate-400">
            ¿Ya tienes una cuenta?
            <router-link to="/login" class="text-indigo-400 hover:text-indigo-300 font-bold transition-colors ml-1 inline-flex items-center">
              Inicia sesión aquí
            </router-link>
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { User, FileText, Mail, Lock, AtSign, Eye, EyeOff, Loader2, AlertCircle } from 'lucide-vue-next';
import apiClient from '@/api/client';
import { useToast } from '@/composables/useToast';

const router = useRouter();
const { showSuccess } = useToast();

const isLoading = ref(false);
const errorMessage = ref('');
const showPassword = ref(false);
const showPasswordConfirm = ref(false);

const form = reactive({
  full_name: '',
  document: '',
  email: '',
  username: '',
  password: '',
  password_confirmation: ''
});

const handleSignup = async () => {
  errorMessage.value = '';

  if (form.password !== form.password_confirmation) {
    errorMessage.value = 'Las contraseñas no coinciden.';
    return;
  }

  if (form.password.length < 6) {
    errorMessage.value = 'La contraseña debe tener al menos 6 caracteres.';
    return;
  }

  isLoading.value = true;

  try {
    const payload = {
      full_name: form.full_name,
      document: form.document,
      email: form.email,
      username: form.username.toLowerCase(),
      password: form.password,
      role_id: 3,
      is_active: 1,
      is_premium: 0
    };

    await apiClient.post('/users', payload);

    showSuccess('Cuenta creada exitosamente. ¡Bienvenido a Neurals!');
    router.push('/login');

  } catch (error) {
    console.error(error);
    errorMessage.value = error.response?.data?.message || 'Hubo un error al crear la cuenta. Verifica si el usuario o correo ya existen.';
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
@keyframes fade-in {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fade-in 0.3s ease-out forwards;
}
</style>